export default "__VITE_ASSET__5bc60849__"